<ng-container *ngIf="cfgIntegracaoEvento">
  <div 
    class="card card-w-title container" 
    [ngClass]="{'container-inativo'  : !(eventoCliente && eventoCliente.status === 'A' && eventoCliente.url), 
                'container-em-edicao': (modo === 'edicao')}"
    >
    <div class="ui-g">
      <div class="ui-g-12">
        <label class="titulo-label-de-ajuda titulo-label-de-ajuda-quando">Quando</label>
        <label 
          class="titulo"
          [ngClass]="(eventoCliente && eventoCliente.status === 'A' && eventoCliente.url) ? 'ativo' : 'titulo-evento-cliente-nao-existe'">
          {{ cfgIntegracaoEvento.label | lowercase }}
        </label>
      </div>

      <!-- modo visualizacao -->
      <div class="content" *ngIf="modo === 'visualizacao'">
        <ng-container *ngIf="eventoCliente">
          <div class="ui-g-12" *ngIf="eventoCliente.url">
            <span class="texto-cinza url-container">
              <label class="titulo-label-de-ajuda">Consumir</label>
              {{ eventoCliente.url }}
            </span>
          </div>
  
          <div class="ui-g-12">
            <span *ngIf="eventoCliente.method">
              <label class="tag" 
                    [ngClass]="[{ 'POST':'tag-warning',
                                  'PUT':'tag-danger',
                                  'DELETE':'tag-pink'}
                               [ eventoCliente.method ]]">
                {{ eventoCliente.method }}
              </label>
            </span>
          </div>
        </ng-container>
      </div>

      <!-- modo edicao -->
      <div class="content-edicao" *ngIf="modo === 'edicao'">
        <div class="ui-g-12 container-edicao-url">
          <span class="md-inputfield">
            <input 
              [disabled]="false"
              [style]="{'width':'100%'}"
              type="text" 
              name="url" 
              [(ngModel)]="novaUrl" 
              pInputText>
            <label class="texto-cinza">Url</label>
          </span>
        </div>            
  
        <div class="ui-g-12 container-edicao-method">
          <label class="texto-cinza">Method:&nbsp;&nbsp;</label>
          <p-dropdown 
            [style]="{'width':'84px'}"
            [options]="methodOptions" 
            [optionLabel]="'label'"
            [styleClass]="'item-ddl'"
            [(ngModel)]="novoMethod">
          </p-dropdown>
        </div>
      </div>     

      <!-- footer -->
      <div class="ui-g-12">
        <div class="footer">
          <div class="footer-itens">
            <span class="footer-item footer-item-primeiro">
              <label 
                class="tag"            
                *ngIf="!eventoCliente">NÃO CADASTRADO</label>

              <!-- Status Ativo e com URL cadastrada -->
              <label 
                class="tag tag-info clickable"   
                (click)="inativar()"
                *ngIf="eventoCliente && eventoCliente.status === 'A' && eventoCliente.url">ATIVO</label>

              <!-- Status Ativo e sem URL cadastrada -->
              <label 
                class="tag"
                *ngIf="eventoCliente && eventoCliente.status === 'A' && !eventoCliente.url">URL NÃO CADASTRADA</label>

              <!-- Status Inativo e sem URL cadastrada -->
              <label 
                class="tag tag-danger clickable" 
                (click)="ativar()"
                *ngIf="eventoCliente && eventoCliente.status === 'I'">INATIVO</label>

            </span>

            <span class="footer-item clickable">
              <a href="javascript:void(0);" (click)="abrirLog()" class="texto-cinza">Logs</a>
            </span>

            <span class="footer-item" *ngIf="modo === 'visualizacao'">
              <button 
                pButton 
                type="button"
                class="botao ui-button-secondary"
                (click)="editar()"
                label="Editar"></button>
            </span>

            <span class="footer-item" *ngIf="modo === 'edicao'">
              <button 
                pButton 
                type="button"
                class="botao ui-button-secondary"
                (click)="cancelarEdicao()"
                label="Cancelar"></button>
            </span>

            <span class="footer-item" *ngIf="modo === 'edicao'">
              <button 
                pButton 
                type="button"
                class="botao ui-button-primary"
                (click)="criarOuAtualizar()"
                label="Salvar"></button>
            </span>
          </div>
        </div>           
      </div>
    </div>



  </div>

</ng-container>
